'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _Dropdown = require('./Dropdown');

var _Dropdown2 = _interopRequireDefault(_Dropdown);

var _MenuItem = require('../MenuItem');

var _MenuItem2 = _interopRequireDefault(_MenuItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FeDropdown = function (_React$Component) {
  _inherits(FeDropdown, _React$Component);

  function FeDropdown(props) {
    _classCallCheck(this, FeDropdown);

    //React components using ES6 classes no longer autobind this to non React methods
    //hence, need to bind this
    var _this = _possibleConstructorReturn(this, (FeDropdown.__proto__ || Object.getPrototypeOf(FeDropdown)).call(this, props));

    _this.handleSelect = _this.handleSelect.bind(_this);
    _this.state = {
      selectedOption: _this.props.selectedOption
    };
    return _this;
  }

  _createClass(FeDropdown, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.selectedOption !== this.props.selectedOption) {
        this.setState({
          selectedOption: nextProps.selectedOption
        });
      }
    }
  }, {
    key: 'onMouseEnter',
    value: function onMouseEnter(event) {
      if (this.props.onMouseEnter) {
        this.props.onMouseEnter(event);
      }
    }
  }, {
    key: 'onMouseLeave',
    value: function onMouseLeave(event) {
      if (this.props.onMouseLeave) {
        this.props.onMouseLeave(event);
      }
    }
  }, {
    key: 'onClick',
    value: function onClick(event) {
      if (this.props.onClick) {
        this.props.onClick(event);
      }
    }
  }, {
    key: 'toggle',
    value: function toggle() {
      _reactDom2.default.findDOMNode(this.togleButton).focus();
      this.menuPanel.refs.inner.toggleOpen();
    }
  }, {
    key: 'resetSelection',
    value: function resetSelection() {
      this.setState({
        selectedOption: this.props.selectedOption
      });
    }
  }, {
    key: 'handleSelect',
    value: function handleSelect(eventKey, event) {
      this.setState({ selectedOption: eventKey });
      if (this.props.dropdownSelectCallback) {
        var eventValue = this.props.dropdownOptions.find(function (option) {
          return option.key === eventKey;
        }).value;
        var returnValue = eventValue === undefined ? eventKey : eventValue;
        this.props.dropdownSelectCallback(returnValue, event);
      }
      this.timeOutId = setTimeout(function (node) {
        return function () {
          if (_reactDom2.default.findDOMNode(node)) {
            _reactDom2.default.findDOMNode(node).blur();
          }
        };
      }(this.togleButton), 0);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.timeOutId) {
        clearTimeout(this.timeOutId);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var classes = void 0;
      if (this.props.dropdownType === 'primary') {
        classes = ['btn-dropdown', this.props.disabled ? 'disabled' : 'btn-primary'];
      } else if (this.props.dropdownType === 'default') {
        classes = ['btn-dropdown', this.props.disabled ? 'disabled' : 'btn-default'];
      } else if (this.props.dropdownType === 'link') {
        classes = ['btn-link', this.props.disabled ? 'disabled' : ''];
      } else if (this.props.dropdownType === 'icon') {
        classes = ['btn-cog', this.props.disabled ? 'disabled' : 'btn-default'];
      } else {
        classes = ['btn-dropdown', this.props.disabled ? 'disabled' : ''];
      }

      var dtype = this.props.dropdownType;
      if (this.props.dropdownType === 'icon' || this.props.dropdownType === 'avatar' || this.props.dropdownType === 'navigation') {
        return _react2.default.createElement(
          _Dropdown2.default,
          { theme: this.props.theme, id: this.props.id, disabled: this.props.disabled, ref: function ref(_ref2) {
              return _this2.menuPanel = _ref2;
            }, dropdownType: this.props.dropdownType, onSelect: this.handleSelect, pullRight: this.props.pullRight || false },
          _react2.default.createElement(
            _Dropdown2.default.Toggle,
            { ref: function ref(_ref) {
                return _this2.togleButton = _ref;
              }, className: classes, noCaret: true },
            this.props.children
          ),
          _react2.default.createElement(
            _Dropdown2.default.Menu,
            null,
            this.props.dropdownOptions.map(function (option, index) {
              if (option.divider || option.header) {
                return _react2.default.createElement(_MenuItem2.default, { key: index, header: option.header, disabled: option.disabled, divider: option.divider });
              } else {
                return _react2.default.createElement(
                  _MenuItem2.default,
                  { key: index, disabled: option.disabled, menuType: dtype, eventKey: option.key, eventValue: option.value },
                  option.key
                );
              }
            })
          )
        );
      } else {
        return _react2.default.createElement(
          _Dropdown2.default,
          { theme: this.props.theme, id: this.props.id, disabled: this.props.disabled, ref: function ref(_ref4) {
              return _this2.menuPanel = _ref4;
            }, dropdownType: this.props.dropdownType, onSelect: this.handleSelect, pullRight: this.props.pullRight || false },
          _react2.default.createElement(
            _Dropdown2.default.Toggle,
            { ref: function ref(_ref3) {
                return _this2.togleButton = _ref3;
              }, className: classes },
            _react2.default.createElement(
              'span',
              null,
              this.state.selectedOption
            )
          ),
          _react2.default.createElement(
            _Dropdown2.default.Menu,
            null,
            this.props.dropdownOptions.map(function (option, index) {
              if (option.divider || option.header) {
                return _react2.default.createElement(_MenuItem2.default, { key: index, disabled: option.disabled, header: option.header, divider: option.divider });
              } else {
                return _react2.default.createElement(
                  _MenuItem2.default,
                  { key: index, disabled: option.disabled, eventKey: option.key, eventValue: option.value },
                  option.key
                );
              }
            })
          )
        );
      }
    }
  }]);

  return FeDropdown;
}(_react2.default.Component);

FeDropdown.propTypes = {
  dropdownOptions: _propTypes2.default.array,
  selectedOption: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  pullRight: _propTypes2.default.bool,
  dropdownType: _propTypes2.default.string,
  dropdownSelectCallback: _propTypes2.default.func,
  onClick: _propTypes2.default.func, // callback for onMouseEnter.
  onMouseEnter: _propTypes2.default.func, // callback for onMouseEnter.
  onMouseLeave: _propTypes2.default.func, // callback for onMouseEnter.
  disabled: _propTypes2.default.bool
};

FeDropdown.defaultProps = {
  dropdownOptions: [],
  selectedOption: '',
  dropdownType: 'primary',
  disabled: false
};

exports.default = FeDropdown;